import React from "react"
import {connect} from "react-redux";
import {deleteDeposit, fetchDeposit} from "../../actions/depositActions";

import {Button, Col, ListGroup, ListGroupItem, Row, Table} from 'reactstrap';
import VerifItem from "./VerifItem";
import {startVerification} from "../../actions/verifActions";
import {push} from "connected-react-router";
import {Link} from "react-router-dom";
import {openModal} from "../../actions/modalActions";

class Deposit extends React.Component {

  fetchDeposit = () => {
    this.props.fetchDeposit(this.props.depo_id)
  }

  deleteDeposit = () => {
    this.props.deleteDeposit(this.props.depo_id)
  }

  startVerification = () => {
    this.props.startVerification(this.props.depo_id)
  }

  componentWillMount() {
    this.props.fetchDeposit(this.props.depo_id)
  }

  render() {
    const {verifications, deposit, fetching, error} = this.props;

    if (!deposit)
      return "Loading"

    const DepoActions = () => {
      if (fetching)
        return null
      else
        return <Col xs={6}>
          <h3>Actions</h3>
          <Button color='primary' onClick={this.startVerification}>Run new verification</Button>{' '}
          <Button tag={Link} to={"/deposits/"+this.props.depo_id+"/edit"}>Edit delivery</Button>{' '}
          <Button color='danger' onClick={() => this.props.dispatch(openModal({
            id: 1,
            type: 'confirm',
            title: 'Are you sure to do this?',
            descr: 'This will delete the delivery entry',
            onConfirm: () => this.deleteDeposit(),
            onClose: () => console.log("fire at closing event"),
          }))}>Delete delivery</Button>
        </Col>
    }

    const verifList = verifications.map(verif => <VerifItem key={verif.id} depo_id={deposit.id} {...verif}/>)
    //verifications.map(verif => <li key={verif.id}><Link to={"/deposits/"+this.props.depo_id+"/verifications/"+verif.id}>Verification {verif.id}</Link></li>)
    return <Row>
      <Col xs={6}>
        <h3>Delivery info</h3>
        <Table>
          <tbody>
            <tr>
              <th width="200px">Delivery name</th>
              <td>{deposit.name}</td>
            </tr>
            <tr>
              <th>Contract ID</th>
              <td>{deposit.contract_id}</td>
            </tr>
            <tr>
              <th>ID</th>
              <td>{deposit.id}</td>
            </tr>
            <tr>
              <th>(FTP) file location</th>
              <td>{deposit.file}</td>
            </tr>
          </tbody>
        </Table>
      </Col>
      <DepoActions/>
      <Col xs={12}>
        <h3>Verifications</h3>
        {verifList.length > 0 ?
          <ListGroup>{verifList}</ListGroup>
          :
          <span>None</span>
        }
      </Col>
    </Row>
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
  fetchDeposit: (depoId) => dispatch(fetchDeposit(depoId)),
  deleteDeposit: (depoId) => dispatch(deleteDeposit(depoId)),
  startVerification: (depoId) => dispatch(startVerification(depoId))
})

const mapStateToProps = (state) => ({
  fetching: state.deposit.fetching,
  deposit: state.deposit.deposit,
  verifications: state.deposit.verifications,
  error: state.deposit.error,
})

export default connect(mapStateToProps, mapDispatchToProps)(Deposit)



// WEBPACK FOOTER //
// ./src/components/Deposits/Deposit.js